import { z } from 'zod';
import { ProposalAccessory } from './proposal-services.js';
import { ProposalContent } from './customer-proposal.js';
import { projectWork } from './customer-pricing.js';
export const ManualTrimPricingMode = z.enum(['included', 'separate']);
export function manualTrimChargingPatch(mode, productId, rate) {
    if (mode === 'included') {
        if (!productId)
            throw Error('Choose the flooring that includes this trim.');
        return { bound_to: productId, rate: null };
    }
    return { bound_to: null, rate };
}
export const ManualTrimRequest = z.object({ content: ProposalContent, accessory_id: z.string().uuid(), name: z.string().trim().min(1).max(160), quantity: z.number().finite().positive().max(1e8), rate: z.number().finite().nonnegative().max(1e9).nullable(), pricing_mode: ManualTrimPricingMode, selection_id: z.string().min(1).max(80).optional() });
export function previewManualTrim(input) {
    const { content, accessory_id, pricing_mode } = input;
    if (content.accessories.length >= 60 || content.accessories.some(row => row.id === accessory_id))
        throw Error('The accessory identity is already present or the Proposal is full.');
    let productId = null, selectionId = null;
    if (pricing_mode === 'included') {
        if (input.rate !== null)
            throw Error('An included trim has no separate customer rate.');
        const selected = content.pricing?.products.filter(row => row.id === input.selection_id) ?? [];
        if (selected.length !== 1)
            throw Error('Choose one flooring selection for the included trim.');
        productId = selected[0].productId;
        selectionId = selected[0].id;
        if (content.pricing.products.filter(row => row.productId === productId).length !== 1)
            throw Error('This flooring product appears more than once; resolve its accessory ownership first.');
    }
    else {
        if (input.selection_id !== undefined)
            throw Error('A separately charged trim is a standalone line.');
        if (input.rate === null)
            throw Error('Enter the agreed rate for a separately charged trim.');
    }
    const row = ProposalAccessory.parse({ id: accessory_id, name: input.name, kind: 'trims', scope: 'site', area_id: '', colour: null, on: true, ...manualTrimChargingPatch(pricing_mode, productId, input.rate), unit: 'LM', quantity: input.quantity, quantity_source: 'manual', note: '', product_id: null, variant_id: null });
    const priced = projectWork([], [row]);
    return { accessory_id, selection_id: selectionId, product_id: productId, pricing_mode, row, subtotal: priced.subtotal, unpriced: priced.unpriced };
}
//# sourceMappingURL=manual-trim.js.map